module.exports = __webpack_public_path__ + "static/icon-timesheets-835f1ff78bf29d95ad69362beee1175e.png";